import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { transaccionAction } from '../../../../application/actions/transaccion';
import { loadersActions } from '../../../../application/actions/ui_loaders';

import api from '../../../api';
const apiTransaccion = api(process.env.REACT_APP_URL);

export function* fetchTransaccionFuncion(trackid) {
  try {
    yield put(loadersActions.changeStatusLoader({ isLoading: true }));

    const { data } = yield call(apiTransaccion.post, 'transaccion/obtener', ' ' , {
        'Track-Id': trackid.payload
     });

    yield put(loadersActions.changeStatusLoader({ isLoading: false }));

    if (data) {
      yield put(transaccionAction.fetchTransaccionSuccess({ respuestaServicio: data }));

    } else {
      yield put(transaccionAction.fetchTransaccionError());

    }

  } catch {
      //Errores
    yield all([
      put(transaccionAction.fetchTransaccionError())
    ]);
  }
}

export function* watchFetchTransaccion() {
  yield takeLatest(transaccionAction.fetchTransaccion.type, fetchTransaccionFuncion);
}

export default function* rootSaga() {
  yield spawn(watchFetchTransaccion);
}
